import * as React from "react";
import type { SVGProps } from "react";
const SvgIcPurchasing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.172 3.744c-2.878 0-4.682 2.044-4.682 4.937v7.807c0 2.893 1.796 4.937 4.682 4.937h8.256c2.887 0 4.683-2.044 4.683-4.937V8.68c0-2.893-1.796-4.937-4.682-4.937"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21.104 13.709H16.91c-.869 0-1.661.493-2.047 1.274a2.86 2.86 0 0 1-2.564 1.596 2.86 2.86 0 0 1-2.564-1.596 2.28 2.28 0 0 0-2.047-1.274h-4.19M15.237 7.945l-2.747 2.66-2.746-2.66M12.49 10.6V3.364"
    />
  </svg>
);
export default SvgIcPurchasing;
